import { Box, Grid, GridProps, Skeleton } from '@mui/material';
import {
	productPLPContentSX,
	productPLPImageSX,
	productPLPSubtitleSX,
	productPLPTitleSX,
} from '@/components/content/CatalogEntryList/styles/typography';
import { combineSX } from '@/utils/combineSX';

interface ProductCardPLPSkeletonProps extends GridProps {
	isFavorite?: boolean;
}

export const ProductCardPLPSkeleton: React.FC<ProductCardPLPSkeletonProps> = ({
	isFavorite = false,
	...rest
}) => (
	<Grid item xs={6} md={4} {...rest}>
		<Box border="1px solid #DADCE0">
			<Skeleton variant="rectangular" sx={productPLPImageSX(isFavorite)} />
			<Box sx={productPLPContentSX(isFavorite)}>
				<Box>
					<Skeleton variant="text" width="100%" sx={productPLPTitleSX(isFavorite)} />
					<Skeleton
						variant="text"
						width="90%"
						sx={combineSX([productPLPSubtitleSX, { fontWeight: '300' }])}
					/>
				</Box>
				<Skeleton variant="text" width="50%" />
			</Box>
		</Box>
	</Grid>
);
